module.exports = __webpack_public_path__ + "static/media/icon_navConnection.27b751e0.svg";